import { useRef as n, useMemo as c } from "react";
import "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import p from "../../core/hooks/useStableOptions.mjs";
import "date-fns";
function O(r, e, i = {}) {
  const t = n(), s = p(i);
  return c(() => (t.current && t.current.dispose(), t.current = r.feeds.initialize(e, s), t.current.store.subscribe((u) => {
    var o;
    return (o = t == null ? void 0 : t.current) == null ? void 0 : o.store.setState(u);
  }), t.current.listenForUpdates(), t.current), [r, e, s]);
}
export {
  O as default
};
//# sourceMappingURL=useNotifications.mjs.map
